import '../assets/NcAppNavigationSpacer-Cb4q1zb5.css';
import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-D637Qkok.mjs";
const _sfc_main = {
  name: "NcAppNavigationSpacer"
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("li", { staticClass: "app-navigation-spacer" });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "3dd6c4f7",
  null,
  null
);
const NcAppNavigationSpacer = __component__.exports;
export {
  NcAppNavigationSpacer as default
};
